import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';

import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from '../../core/storage/storage.service';
import RequestEnterprise from 'src/app/shared/model/requestEnterprise.enum';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { DeliveryLocation } from 'src/app/shared/model/location.enum';
import { AuthorizerUsers, User } from '../../shared/model/user.model';
import { Vehicles, PccVehicle } from '../../shared/model/vehicle.model';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { StockVehicle } from 'src/app/shared/model/campaign.model';
import {
  EndowmentLeasingType,
  OrderRequest,
  PetitionerRequest,
  ReplacementVehicleRequest,
  RequestedNewVehicle
} from 'src/app/shared/model/order.model';
import { GenerateNewOrderObj } from '../../shared/utils/generateNewOrderObj';

import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
  standalone: true,
  selector: 'app-leasing-endoment-request',
  templateUrl: './leasing-endowment-request.component.html',
  styleUrls: ['./leasing-endowment-request.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatFormFieldModule,
    StepperComponent
  ]
})
export class LeasingEndowmentRequestComponent
  implements OnChanges, OnInit, AfterViewInit
{
  @ViewChild('stepperHeader') stepperHeader!: ElementRef;
  configCode = '';
  disableVehicle = false;
  existVehicles = false;
  vinNumberAssign = '';
  typeTranslation = '';
  user!: User;
  types!: RequestType;
  requestType = RequestType.dotArr;
  vehicleInfoData!: PccVehicle;
  vehicleType = '';
  vehiclesArr: Vehicles[] = [];
  newRequest!: OrderRequest;
  orderType = '';
  spinner = false;
  removeData = false;
  pssFinalDate!: Date;
  data = '';
  isFirstAssign = false;
  retribution!: string;
  newVehicle?: RequestedNewVehicle;
  replacementVehicle?: ReplacementVehicleRequest | null;
  estimatedKmsData?: number;
  petitioner?: PetitionerRequest;
  requestSubtype = '';
  requestObj!: OrderRequest;
  ad?: boolean;
  newRequestType = '';
  isDetail = false;
  controller?: AuthorizerUsers;
  extraEmail = '';
  extraPhone = '';
  selectedVehicleType = 'configurator';
  stockVehicle?: Vehicles;
  leaseEndowType = 'empty';

  //errores
  nisError = false;
  addDataError = '';
  isKmsExceeded = false;
  errorPcc = false;
  errorPccText = '';
  errorKms = false;
  errorNisFunction = false;
  errorNisFunctionText = '';
  //Stepper
  isLinear = true;

  steps = new Map<string, boolean>();

  landing2 = false;
  requestCarType = null;
  isVip = false;
  loading = false;
  isPhone = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private generateNewOrderObj: GenerateNewOrderObj,
    private navigationService: NavigationService,
    private utilsService: UtilsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['leaseEndowType']) {
      this.setLeaseEndowSteps(this.leaseEndowType);
    }
  }
  ngOnInit(): void {
    this.isPhone = this.utilsService.isPhone();
    this.landing2 = this.storageService.get('landing2') || false;
    this.requestCarType = this.storageService.get('requestCarType') || null;
    this.storageService.set('navigation', 'newRequest');
    this.user = this.storageService.get('config');
    if (this.storageService.get('ad')) {
      this.ad = this.storageService.get('ad');
    }
    if (
      this.storageService.get('config') &&
      this.storageService.get('requestCarType')
    ) {
      this.isVip =
        ['PRESI', 'VICE', 'TMK'].includes(
          this.storageService.get('config').category
        ) &&
        this.storageService.get('requestCarType') ===
          'endowmentLeasingEndowment';
    }
    if (this.ad === true) {
      this.router.navigateByUrl('/landing');
    }
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['orderList'] === 'true') {
        this.router.navigateByUrl('/list-request');
      }
    });
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  @HostListener('window:resize')
  onResize() {
    if (this.leaseEndowType !== 'empty') {
      this.adjustStepper();
    }
  }

  setLeaseEndowSteps(type: string) {
    this.leaseEndowType = type;
    this.setSteps();
    setTimeout(() => {
      this.adjustStepper();
    }, 100);
  }

  generateRequestObject(newRequestData: any) {
    const orderInfo = {
      requestType: RequestType.dotArr,
      comments: newRequestData.comments,
      controllerUserId: !!newRequestData.controller
        ? newRequestData.controller.id
        : null
    };
    let newVehicle: PccVehicle | null = null;
    let stockVehicle: StockVehicle | null = null;

    if (newRequestData.vehicleInfo?.type === 'configurator') {
      newVehicle = {
        ...newRequestData.vehicleInfo.data,
        configCode: newRequestData.vehicleInfo.configCode
      };
    } else if (newRequestData.vehicleInfo?.type === 'stock') {
      stockVehicle = { VIN: newRequestData.vehicleInfo.data.VIN };
    }

    const phone = !!newRequestData.extraPhone
      ? newRequestData.extraPhone.trim()
      : null;
    const email = !!newRequestData.extraEmail
      ? newRequestData.extraEmail.trim()
      : null;

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    if (
      newRequestData.requestInfo?.subtype === 'SUBSTITUTION' &&
      !!newRequestData.replacementVehicleInfo
    ) {
      this.replacementVehicle = newRequestData.replacementVehicleInfo;
    } else {
      this.replacementVehicle = null;
    }

    const endowmentLeasingData: EndowmentLeasingType = {
      orderType: newRequestData.requestInfo?.type,
      orderSubType:
        newRequestData.requestInfo?.subtype === 'SUBSTITUTION'
          ? 'SUBSTITUTION'
          : 'FIRST_ASSIGNMENT',
      groupType: this.user?.groupType,
      retribution: newRequestData.retribution,
      replacedVehicle: newRequestData.replacementVehicleInfo,
      stockVehicle: stockVehicle,
      newVehicle:
        newVehicle === null
          ? null
          : this.generateNewOrderObj.mapNewVehicle(newVehicle, this.isVip),
      deliveryLocation: newRequestData.requestInfo?.deliveryLocationChecked
        ? DeliveryLocation.MARTORELL
        : undefined,
      checkMartorell: newRequestData.requestInfo?.deliveryLocationChecked
    };
    this.requestObj = {
      orderInfo: { ...orderInfo },
      endowmentLeasingData: { ...endowmentLeasingData },
      contactInfoDataDTO: { ...contactInfoDataDTO }
    };
  }

  openConfirmationModal() {
    this.loading = true;
    this.coreService.newOrder(this.requestObj).subscribe({
      next: () => {
        this.loading = false;
        if (this.requestObj && this.requestObj.endowmentLeasingData) {
          const queryParams = {
            orderType: this.requestObj.endowmentLeasingData.orderType,
            orderSubType: this.requestObj.endowmentLeasingData.orderSubType,
            substitutionRequestNumber:
              this.requestObj.endowmentLeasingData.replacedVehicle
                ?.requestNumber
          };
          this.router.navigate(['request-completed'], { queryParams });
        }
      },
      error: () => {
        this.loading = false;
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('newRequestKO'),
            close: true,
            theme: 'ligth'
          },
          disableClose: true
        });
      }
    });
  }

  sendRequest(newRequestData: any) {
    this.generateRequestObject(newRequestData);
    if (!!newRequestData.retribution) {
      this.openConfirmationModal();
    } else {
      this.dialog.open(FeedbackModalComponent, {
        data: {
          text: i18next.t('errorRetribution'),
          close: true,
          theme: 'ligth'
        },
        disableClose: true
      });
    }
  }

  setSteps() {
    if (this.leaseEndowType === 'stock') {
      this.steps.set('approvers', this.needAuthorization());
      this.steps.set('request-info', false);
      this.steps.set('stockVehicle', true);
      this.steps.set('car-config', false);
      this.steps.set('replacementvehicle', false);
      this.steps.set('additionalInfo', true);
      this.steps.set('resume', true);
    } else if (this.leaseEndowType === 'config') {
      this.steps.set('approvers', this.needAuthorization());
      this.steps.set('request-info', false);
      this.steps.set('stockVehicle', false);
      this.steps.set('car-config', true);
      this.steps.set('replacementvehicle', false);
      this.steps.set('additionalInfo', true);
      this.steps.set('resume', true);
    } else {
      this.steps.set('approvers', this.needAuthorization());
      this.steps.set('request-info', true);
      this.steps.set('car-config', true);
      this.steps.set('replacementvehicle', true);
      this.steps.set('additionalInfo', true);
    }
  }

  needAuthorization(): boolean {
    let needAuthorization = false;
    if (
      this.user?.enterprise === RequestEnterprise.MT ||
      this.user?.enterprise === RequestEnterprise.XM ||
      this.user?.enterprise === RequestEnterprise.CD
    ) {
      needAuthorization = true;
    } else {
      needAuthorization = false;
    }

    return needAuthorization;
  }

  adjustStepper() {
    const stepperHeaderContainer: any = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (stepperHeaderContainer) {
      //scale 0.8
      stepperHeaderContainer.style.transform = 'scale(0.8)';
      stepperHeaderContainer.style.transformOrigin = 'center right';

      const offY = stepperHeaderContainer.offsetHeight / 2;

      const stepperHeader = this.stepperHeader.nativeElement;
      const x = stepperHeader.getBoundingClientRect().x;

      const right = window.innerWidth - x;
      stepperHeaderContainer.style.position = 'absolute';
      stepperHeaderContainer.style.top = stepperHeader.offsetTop - offY + 'px';
      stepperHeaderContainer.style.right = right + 'px';
    }
    if (stepperHeaderContainer && window.innerWidth <= 1024) {
      stepperHeaderContainer.style.transformOrigin = 'center left';
      stepperHeaderContainer.style['flex-wrap'] = 'wrap';
      stepperHeaderContainer.style.position = 'unset';
    }
  }

  initial() {
    this.leaseEndowType = 'empty';
    this.steps = new Map<string, boolean>();
  }
}
